//product 产品服务
import React from 'react';
import '../CSS/style.css';
import {Col, Row} from "antd";
import productPic from '../Home/img/productPic.png'
import service from '../Home/img/service.png'
import ABI from '../Home/img/ABI.png'
import serviceLevel from '../Home/img/serviceLevel.png'
import { titleSize, contentColor, contentSize, subSubTitleSize, subtitleSize } from './../Utils/CommonVar';

import { scrollToTop } from './../Utils/CommonFunc';

export default class Product extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ifShowImage: false,
        }
    }
    componentDidMount() {
        scrollToTop(0);
        const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        this.setIfShowImage(width);
        window.onresize = () => {
            const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
            this.setIfShowImage(width);
        };
    }
    setIfShowImage = (width) => {
        if (width < 1100) {
            this.setState({ ifShowImage: false })
        } else {
            this.setState({ ifShowImage: true })
        }
    };

    render() {
        const { ifShowImage } = this.state;
        const width = (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) - 17;
        const height = width / 4;
        return(
            <div style={{marginTop:72}}>
                {/*banner*/}
                <div style={{maxHeight:474, zIndex: 2, position: 'relative'}}>
                    <img src={productPic} alt='picture' width={width} height={height}/>
                </div>
                {/*part 1*/}
                {/*服务简介*/}
                <div id="service">
                    <div style={{background:"#fff"}}>
                        <div className="all" style={{width:1200}}>
                            <Row style={{padding: '64px 60px'}}>
                                <Row>
                                    <div style={{paddingBottom:48}}>
                                        <Row type="flex" justify="center">
                                            <Row>
                                                <Row style={{fontSize:titleSize,textAlign:"center",color:contentColor,fontWeight:500,lineHeight:1.5}}>
                                                    服务简介
                                                </Row>
                                                <Row style={{fontSize:subtitleSize,textAlign:"center",color:contentColor,lineHeight:1.5,marginBottom:15}}>
                                                  Service Summary
                                                </Row>
                                                <Row style={{fontSize: contentSize,textAlign:"center",color:contentColor,lineHeight:1.5}}>
                                                    整体规划咨询、软硬件集成、智能应用开发、经营决策支持
                                                </Row>
                                            </Row>
                                        </Row>
                                    </div>
                                </Row>
                                <Row type="flex" justify="center" align="middle">
                                    <div style={{width:1200}}>
                                        <Row type="flex" align="middle">
                                            <img src={service} alt='picture' width='100%' height='100%'/>
                                        </Row>
                                    </div>
                                </Row>
                            </Row>
                        </div>
                    </div>
                </div>
                {/*服务水平*/}
                <div id="service">
                    <div style={{background:"#F2F6F9"}}>
                        <div className="all" style={{width:1200}}>
                            <Row style={{padding: '64px 60px'}}>
                                <Row>
                                    <div style={{paddingBottom:48}}>
                                        <Row type="flex" justify="center">
                                            <Row>
                                                <Row style={{fontSize:titleSize,textAlign:"center",color:contentColor,fontWeight:500,lineHeight:1.5}}>
                                                    服务水平
                                                </Row>
                                                <Row style={{fontSize:subtitleSize,textAlign:"center",color:contentColor,lineHeight:1.5,marginBottom:15}}>
                                                  Service Level
                                                </Row>
                                                <Row style={{fontSize: contentSize,textAlign:"center",color:contentColor,lineHeight:1.5}}>
                                                    规划高度、算法深度、集成广度、决策粘度
                                                </Row>
                                            </Row>
                                        </Row>
                                    </div>
                                </Row>
                                <Row type="flex" justify="center" align="middle">
                                    <div style={{width:1200}}>
                                        <Row type="flex" align="middle">
                                            <img src={serviceLevel} alt='picture' width='100%' height='100%'/>
                                        </Row>
                                    </div>
                                </Row>
                            </Row>
                        </div>
                    </div>
                </div>
                {/*ABI*/}
                <div id="ABI">
                    <div style={{background:"#fff"}}>
                        <div className="all" style={{width:1200}}>
                            <Row style={{padding: '64px 60px'}}>
                                <Row>
                                    <div style={{paddingBottom:48}}>
                                        <Row type="flex" justify="center">
                                            <Row>
                                                <Row style={{fontSize:titleSize,textAlign:"center",color:contentColor, fontWeight:500,lineHeight:1.5}}>
                                                    ABI 平台
                                                </Row>
                                                <Row style={{fontSize:subtitleSize,textAlign:"center",color:contentColor,lineHeight:1.5,marginBottom:15}}>
                                                  ABI Platform
                                                </Row>
                                                <Row style={{fontSize: contentSize,textAlign:"center",color:contentColor,lineHeight:1.5}}>
                                                    数字化转型、网络化重构、智能化提升
                                                </Row>
                                            </Row>
                                        </Row>
                                    </div>
                                </Row>
                                <Row type="flex" justify="center" align="middle">
                                    <div style={{width:1200}}>
                                        <Row type="flex" justify="space-between" align="middle">
                                            <img src={ABI} alt='picture' width='100%' height='100%' style={{display: 'block'}}/>
                                        </Row>
                                    </div>
                                </Row>
                            </Row>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
